import React from 'react';
import type { NextPage, GetServerSideProps } from 'next';
import { ModularPageWrapper } from '../../components/ModularPageWrapper/ModularPageWrapper';
import {
  type DynamicPageParams,
  dynamicSlugHandler,
  type DynamicSlugPageProps,
} from '../../features/contentstack/utils/dynamicSlugHandler';
import { getDynamicAdsHeroModulesForSlugPage } from '../../features/dynamicAds/utils/getDynamicAdsHeroModulesForSlugPage';

export const getServerSideProps: GetServerSideProps<
  DynamicSlugPageProps,
  DynamicPageParams
> = async ({ req, params }) => {
  const entryResponse = await dynamicSlugHandler({ params, rootPath: '/all' });

  if ('notFound' in entryResponse) {
    return entryResponse;
  }

  const { modules } = entryResponse.props;

  // override the hero module with the dynamic ads hero module only if the
  // request is a dynamic ads landing page (/d/*) - example: /d/all/page-slug
  const dynamicAdsHeroModules = await getDynamicAdsHeroModulesForSlugPage({
    req,
    modules,
    businessLinePage: 'gateway',
  });

  return {
    props: {
      ...entryResponse.props,
      modules: dynamicAdsHeroModules ?? modules,
    },
  };
};

const DynamicPage: NextPage<DynamicSlugPageProps> = props => {
  return <ModularPageWrapper {...props} />;
};

export default DynamicPage;
